import ServiceBase from './ServiceBase';

export default class ProjectCatalogCategoriesService extends ServiceBase {
    getAdminProjectCatalogCategories(showHidden = false) {
        return this.request('get', 'admin/projectCatalogCategories/getProjectCatalogCategories', { params: { showHidden } });
    }

    getProjectCatalogCategories() {
        return this.request('get', 'projectCatalogCategories/getProjectCatalogCategories');
    }
}
